export enum UtilityCategory {
  WATER = 'water',
  ELECTRICITY = 'electricity',
  GAS = 'gas',
  OIL = 'oil',
  OTHER = 'other',
}

export enum GhgScope {
  SCOPE_1 = 1,
  SCOPE_2 = 2,
}

export interface UtilityActivityType {
  id: string;
  key: string;
  label: string;
  category: UtilityCategory;
  canonical_unit: string;
  ghg_scope: GhgScope | null;
  is_active: boolean;
  sort_order: number;
  notes: string | null;
}

export interface UtilityActivityInput {
  utility_type_key: string;
  consumption: number;
  amount_sar: number;
}

export interface UtilityActivityLine extends UtilityActivityInput {
  label: string;
  category: UtilityCategory;
  canonical_unit: string;
  ghg_scope: GhgScope | null;
  factor_version_label: string | null;
  emissions_tco2e: number | null;
  missing_factor: boolean;
}

export interface ScopeEmissionsSummary {
  scope_1_tco2e: number | null;
  scope_2_tco2e: number | null;
  scope_1_complete: boolean;
  scope_2_complete: boolean;
  missing_factor_utility_keys: string[];
  activity_lines: UtilityActivityLine[];
}
